const C = {
  name: "Sliders2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.8293 4C17.4175 2.83481 16.3062 2 15 2C13.6938 2 12.5825 2.83481 12.1707 4L2 4V6L12.1707 6C12.5825 7.16519 13.6938 8 15 8C16.3062 8 17.4175 7.16519 17.8293 6L22 6V4L17.8293 4ZM15 4C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5C14 4.44772 14.4477 4 15 4Z" fill="currentColor"/>
<path d="M5 9C6.30622 9 7.41746 9.83481 7.82929 11L22 11V13L7.82929 13C7.41746 14.1652 6.30622 15 5 15C3.34315 15 2 13.6569 2 12C2 10.3431 3.34315 9 5 9ZM5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11Z" fill="currentColor"/>
<path d="M12 22C10.6938 22 9.58254 21.1652 9.17071 20H2V18H9.17071C9.58254 16.8348 10.6938 16 12 16C13.3062 16 14.4175 16.8348 14.8293 18H22V20H14.8293C14.4175 21.1652 13.3062 22 12 22ZM13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Sliders2
};
